<template>
    <div>
        <v-row dense>
            <v-col>
                <v-card>
                    <v-card-title>
                        Totale Negozi
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-data-table :item-class="rowClass" :hide-default-footer="true" :headers="headersIncassi"
                        :items="totalData" item-key="id" :items-per-page="15" class="elevation-1" calculate-widths>
                        <template v-slot:item.diff="{ item }">
                            <span v-if="item.diff > 0" style="color:green">
                                <b>{{ item.diff }}</b>
                            </span>
                            <span v-else style="color:red">
                                <b>{{ item.diff }}</b>
                            </span> %
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <v-card>
                    <v-card-title>
                        Totale Scontrini
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-data-table :item-class="rowClass" :hide-default-footer="true" :headers="headersScontrini"
                        :items="totalData" item-key="id" :items-per-page="15" class="elevation-1" calculate-widths>
                        <template v-slot:item.diff="{ item }">
                            <span v-if="item.diff > 0" style="color:green">
                                <b>{{ item.diff }}</b>
                            </span>
                            <span v-else style="color:red">
                                <b>{{ item.diff }}</b>
                            </span> %
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <v-card>
                    <v-card-title>
                        Totale Franchising
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-data-table :item-class="rowClass" :hide-default-footer="true" :headers="headersIncassi"
                        :items="totalDataFraschise" item-key="id" :items-per-page="15" class="elevation-1" calculate-widths>
                        <template v-slot:item.diff="{ item }">
                            <span v-if="item.diff > 0" style="color:green">
                                <b>{{ item.diff }}</b>
                            </span>
                            <span v-else style="color:red">
                                <b>{{ item.diff }}</b>
                            </span> %
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <v-card>
                    <v-card-title>
                        Totale Scontrini Franchise
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-data-table :item-class="rowClass" :hide-default-footer="true" :headers="headersScontrini"
                        :items="totalDataFraschise" item-key="id" :items-per-page="15" class="elevation-1" calculate-widths>
                        <template v-slot:item.diff="{ item }">
                            <span v-if="item.diff > 0" style="color:green">
                                <b>{{ item.diff }}</b>
                            </span>
                            <span v-else style="color:red">
                                <b>{{ item.diff }}</b>
                            </span> %
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<style lang="scss" scoped>
.v-data-table::v-deep {

    .background-blue {
        background-color: aqua;
    }

    .background-green {
        background-color: greenyellow;
    }

    .v-data-table-header {
        background-color: #dddddd;

    }

    .total-class {
        background-color: #ddd;
        font-weight: bold;
    }

    .column-text-bold {
        font-weight: bold;
    }
}
</style>
<script>
import { type } from "jquery";
import requests from "../requests";
export default {
    name: "totale-fatturati",

    props: {
        yearFrom:{
            type: Number,
            required: true
        },
        yearTo:{
            type: Number,
            required: true
        },
        shopIds:{
            type: Array,
            default: () => [],
            required:false
        }
    },

    watch: {
        yearFrom() {

            this.createHeadearIncassi();
            this.createHeadearScontrini();
            this.getTotali();
        }
    },
    data: () => {
        return {
            totalData: [],
            totalDataFraschise: [],
            headersIncassi: [],
            headersScontrini: [],
        };
    },
    mounted() {
        console.log("Totale fatturati, Mounted!");
        this.createHeadearIncassi();
        this.createHeadearScontrini();
        this.getTotali();
    },
    methods: {
        getTotali() {
            requests.getIncassiPerAnnoTotale(this.yearFrom, 'shop', this.shopIds).then(res => {
                this.totalData = res.data;
            });
            requests.getIncassiPerAnnoTotale(this.yearFrom, 'franchise', this.shopIds).then(res => {
                this.totalDataFraschise = res.data;
            })
        },
        createHeadearIncassi() {
            this.headersIncassi = [];
            this.headersIncassi.push(
                { text: "Mese", value: "mese", divider: true, sortable: false },
            );

            for (let i = this.yearFrom; i >= this.yearTo; i--) {
                this.headersIncassi.push({
                    text: i, value: "anno_" + i, divider: true, sortable: false, cellClass: 'column-text-bold'
                });
            }

            this.headersIncassi.push(
                { text: "Diff % sul " + this.yearTo, value: "diff", divider: true, sortable: false },
            )
        },

        createHeadearScontrini() {
            this.headersScontrini = [];
            this.headersScontrini.push(
                { text: "Mese", value: "mese", divider: true, sortable: false },
            );

            for (let i = this.yearFrom; i >= this.yearTo; i--) {
                this.headersScontrini.push({
                    text: i, value: "scontrini_" + i, divider: true, sortable: false, cellClass: 'column-text-bold'
                });
            }

            this.headersScontrini.push(
                { text: "Diff % sul " + this.yearTo, value: "diff", divider: true, sortable: false },
            )
        },
        rowClass(item) {
            if (item.mese == 'TOTALE') {
                return 'total-class';
            }
            return '';
        },
    },
};
</script>
